import { useCallback, useEffect, useMemo, useState } from 'react';

import { useSelector } from 'react-redux';

export const useDivisionsSelector = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [divisionsSelected, setDivisionsSelected] = useState({ ids: [], selectedAll: false });
  const userOrgDivisions = useSelector(({ divisions }) => divisions?.assigned?.data?.divisions);

  const items = useMemo(() => {
    let divisions = Object.values(userOrgDivisions || {})
      .map(division => ({
        id: division.id,
        name: division.name,
      }))

    if (!searchTerm) return divisions;
    const lowerSearch = searchTerm.toLowerCase();
    return divisions.filter(div => div.name?.toLowerCase().includes(lowerSearch))
      .filter(Boolean);
  }, [userOrgDivisions, searchTerm]);

  const search = useCallback((term) => {
    setSearchTerm(term || '');
  }, []);

  const reset = useCallback(() => {
    setSearchTerm('');
    setDivisionsSelected({ ids: [], selectedAll: false });
  }, []);

  const handleChange = useCallback((ids) => {
    const selectedAllItems = ids?.length === items?.length;
    const idsToSet = selectedAllItems ? [] : ids;
    setDivisionsSelected({ ids: idsToSet, selectedAll: selectedAllItems });
    return idsToSet;
  }, []);


  return {
    items,
    search,
    reset,
    divisionsSelected,
    handleChange
  };
};
